module.exports = __webpack_public_path__ + "assets/img/8cfd51c3629b44d7d02cdc4e36a60ad1.png";